import { GetAccessTokenResponse } from '@/src/app/api/auth/get-access-token/route';
import { createClient } from '@/src/lib/http/client/client';

export async function getAccessTokenClient() {
  const client = createClient();
  const response = await client.get('/auth/get-access-token', { cache: 'no-store' });
  const handledResponse = await client.handleResponse<GetAccessTokenResponse>(response);

  if (handledResponse.error) {
    throw new Error(handledResponse.error);
  }

  return handledResponse;
}
